export const getCustomerDetails = (customer) => {
  if (Boolean(customer)) {
    const {firstName, lastName, idNumber, phone, email} = customer;
    const name = [firstName, lastName].filter(Boolean).join(' ');

    return {
      name: name || '-',
      idNumber: idNumber || '-',
      phone: phone || '-',
      email: email || '-',
    };
  } else {
    return {
      name: '-',
      idNumber: '-',
      phone: '-',
      email: '-',
    };
  }
};
